import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import MainLayout from "./layouts/MainLayout";
import Customers from "./pages/Customers";
import CustomerDetails from "./pages/CustomerDetails";
import CareHomes from "./pages/CareHomes";
import CareHomeDetails from "./pages/CareHomeDetails";
import Login from "./pages/Login";
import DuplicateAuditWorkbench from "./pages/manager/DuplicateAuditWorkbench";
import LegacyCustomerRedirect from "./pages/LegacyCustomerRedirect";
import { NAVIGATION_CONFIG } from "./config/api";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path={NAVIGATION_CONFIG.ROUTES.SIGNIN}
          element={
            <UnauthenticatedTemplate>
              <Login />
            </UnauthenticatedTemplate>
          }
        />
        <Route
          path={NAVIGATION_CONFIG.ROUTES.HOME}
          element={
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={{
                scopes: ["api://d0d1836c-d51d-4f43-9eee-1d6a58885b8a/.default"],
              }}
            >
              <MainLayout />
            </MsalAuthenticationTemplate>
          }
        >
          {" "}
          <Route index element={<Navigate to={NAVIGATION_CONFIG.ROUTES.CUSTOMERS} replace />} />
          <Route path={NAVIGATION_CONFIG.PATH_SEGMENTS.CUSTOMERS} element={<Customers />} />{" "}
          <Route path={NAVIGATION_CONFIG.PATH_SEGMENTS.CUSTOMERS_WITH_ID} element={<CustomerDetails />} />
          <Route path={NAVIGATION_CONFIG.PATH_SEGMENTS.CARE_HOMES} element={<CareHomes />} />
          <Route path={NAVIGATION_CONFIG.PATH_SEGMENTS.CARE_HOMES_WITH_ID} element={<CareHomeDetails />} />
          <Route
            path={NAVIGATION_CONFIG.PATH_SEGMENTS.MANAGER_DUPLICATE_AUDITS}
            element={<DuplicateAuditWorkbench />}
          />
          <Route
            path={NAVIGATION_CONFIG.PATH_SEGMENTS.CUSTOMERS_LEGACY}
            element={<LegacyCustomerRedirect />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
